// @core/api/endpoints/fiscalization/update_fiscal_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FiscalPolicyResponse,
  UpdateFiscalPolicyRequest,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Update fiscal policy
 * Updates an existing fiscal policy.
 */
export async function UpdateFiscalPolicy(
  policy_id: string,
  data: UpdateFiscalPolicyRequest,
  options?: RequestOptions
): Promise<FiscalPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<FiscalPolicyResponse>(requestPath, data, requestOptions);
}
